// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3eDrd","loadingShrink":"PageLoading_loadingShrink__3DP94"};